import React from 'react';
import { Image as ImageIcon } from 'lucide-react';
import { useI18n } from '../../hooks/useI18n';

export const ImageGeneratingTile = ({ prompt = '' }) => {
  const { t } = useI18n();

  return (
    <div
      className="flex aspect-square flex-col justify-between overflow-hidden rounded-2xl bg-[#F3F4F6] p-4 dark:bg-neutral-900"
      role="status"
      aria-live="polite"
      aria-label={t('imageGeneratingStatus')}
    >
      <div className="flex items-center gap-2 text-neutral-500">
        <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-white dark:bg-neutral-800">
          <ImageIcon size={16} aria-hidden />
        </span>
        <span className="text-sm font-medium">{t('imageGeneratingStatus')}</span>
      </div>
      <div className="space-y-2">
        <div className="skeleton-shimmer h-3 w-4/5 rounded-full" />
        <div className="skeleton-shimmer h-3 w-2/3 rounded-full" />
        {prompt ? (
          <p className="line-clamp-2 text-xs text-neutral-500">{prompt}</p>
        ) : null}
      </div>
    </div>
  );
};

export const ImageGallerySkeleton = ({ count = 8 }) => (
  <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
    {Array.from({ length: count }).map((_, index) => (
      <div key={`image-skel-${index}`} className="skeleton-shimmer aspect-square rounded-2xl" aria-hidden="true" />
    ))}
  </div>
);
